import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useEffect } from "react";
import { css } from "styled-components";

const enum fields {
    region = "region",
    portalId = "portalId",
    formId = "formId",
    target = "target",
    css = "css",
}

interface Props extends WidgetProps {
    fields: {
        [fields.region]: string;
        [fields.portalId]: number;
        [fields.formId]: string;
        [fields.target]: string;
        [fields.css]: string;
    };
}

const CENHubspotScriptForm: React.FunctionComponent<Props> = props => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if ((window as any).hbspt !== undefined) {
                (window as any).hbspt.forms.create({
                    region: props.fields.region,
                    portalId: props.fields.portalId,
                    formId: props.fields.formId,
                    target: "#hubspot",
                    css: props.fields.css,
                });
            }
        });

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return <div id="hubspot"></div>;
};

const widgetModule: WidgetModule = {
    component: CENHubspotScriptForm,
    definition: {
        group: "Basic",
        icon: "Rtf",
        displayName: "CEN Hubspot Form",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.region,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.portalId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.formId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.css,
                editorTemplate: "MultilineTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
